module.exports = __webpack_public_path__ + "img/inspiring.3c602f9a.png";